export default __webpack_public_path__ + "static/media/1d.2d20e7ec.jpg";